import React from 'react'
import TimeAgo from 'react-timeago'
import { useQuery } from 'react-query'
import { useNavigate, useParams } from 'react-router-dom'
import { BsEmojiSmileUpsideDown } from "react-icons/bs";
import Service from '../../Service/http'
import "../TimeLine.css";
import Loader from '../Loader/Loader';

const BatchHistory = () => {

    const batchName = useParams().batchName
    const service = new Service();
    const navigate = useNavigate()
    
    const getBatchHistory = () => {
        const response = service.get(`api/batch/history/${batchName}`);
        return response;
    }

    const { data, isLoading: loading } = useQuery(['batchHistory', batchName], getBatchHistory, {
        onSuccess(json) {
            console.log(json);
        },
        onError(error) {
            console.error(error);
        },
        refetchOnWindowFocus : false
    });

    return (
        <> 
        {
            !loading ? <div className='container w-100' style={{ height: '90vh'}}>
                <h2 className='text-center my-3' style={{ color : '#3496db' }}>{batchName}</h2>
                <div className='bg-secondary' style={{ height: '3px' }}></div>
                <div className='container overflow-auto py-3' style={{ height: '90%', borderRadius: 10 }}>
                    <div className={data?.data?.length !== 0 ? "timeline-all-timelines" : 'd-flex justify-content-center'}>
                        {data?.data?.length === 0 ? (
                            <div className='w-100'>
                                <span className='d-block text-center'><BsEmojiSmileUpsideDown size={40}/></span>
                                <h4 className='text-center my-2'>No Data Found</h4>
                            </div>
                        ) : (
                            data?.data?.map((historyObj, idx) => {
                                return (
                                    <div className="timeline-single-timeline timeline-d-flex-2" key={idx}>
                                        <div className="timeline-blank"></div>
                                        <div className="timeline-text timeline-d-flex-2">
                                            <span>
                                                <u>
                                                    <h6>
                                                        <strong 
                                                            style={{ color: 'purple',cursor:"pointer",display:"inline" }} 
                                                            onClick={()=>navigate("/profile/"+historyObj?.updatedBy?._id)}
                                                            >
                                                            {historyObj?.updatedBy?.name}
                                                        </strong>
                                                        <span 
                                                            className={`text-${historyObj.action === 'remove' ? 'danger' : 'success'}`}
                                                        >
                                                            {historyObj?.action === 'remove' ? 'removed' : 'added'}
                                                        </span>
                                                        <strong style={{ color: 'green',display:"inline" }}>{historyObj?.userId.name} </strong>
                                                            at{' '}
                                                        {new Date(historyObj?.createdAt).toLocaleString('en-US', {
                                                            year: 'numeric',
                                                            month: '2-digit',
                                                            day: '2-digit',
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            second: '2-digit',
                                                            hour12: true, // Display time in 12-hour format
                                                        })}
                                                    </h6>
                                                </u>
                                                <p>
                                                { historyObj?.updatedAt&&<TimeAgo date={new Date(historyObj?.updatedAt)} />}
                                                </p>
                                            </span>
                                            <div className="timeline-t-square"></div>
                                        </div>
                                    </div>
                                );
                            })
                        )}
                    </div>
                </div>
            </div>
            : <Loader />}
        </>
    )
}

export default BatchHistory